import { combineReducers } from "redux"
import regionStatisticsReducer from "./regionStatisticsReducer"
import searchReducer from "./searchReducer"
import companyReducer from "./companyReducer"
import branchReducer from "./branchReducer"
import profinderIndustryReducer from "./profinderIndustryReducer"
import filterOptionReducer from "./filterOptionReducer"

const rootReducer = combineReducers({
  regionStatistics: regionStatisticsReducer,
  search: searchReducer,
  company: companyReducer,
  branch: branchReducer,
  profinderIndustries: profinderIndustryReducer,
  filterOptions: filterOptionReducer,
})

export default rootReducer
